import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'breakStatusDescr'
})
export class BreakStatusDescrPipe implements PipeTransform {

  transform(value: string): string {
    const descriptions: { [key: string]: string } = {
      1: 'Open',
      2: 'Accepted',
      3: 'Denied',
      4: 'Completed'
    };

    return descriptions[value] || 'Unknown status';
  }

}
